/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { clientUtil } from "@html-core";
import { Injectable } from "@angular/core";
import { UrlParameterService } from "../../../chrome-client/desktop/blast-common/url-parameter.service";
import { IWARxBridgeChannel } from "./iwa-rx-bridge-channel";
import { RXBaseService } from "../../../native-shared/desktop/rx-base.service";

@Injectable()
export class IwaRXService extends RXBaseService {
   constructor(
      private rxBridgeChannel: IWARxBridgeChannel,
      private urlParameterService: UrlParameterService
   ) {
      super();
   }

   public init = (sessionKey) => {
      // create proxy channels
      const channelEnableStatus = {
         CDR: true,
         RTAV: !!this.urlParameterService.launchSettings.useRTAVChannel,
         usbRedirection: true
      };
      const rxParameters = this.urlParameterService.launchSettings.rxParameters;
      this.rxBridgeChannel.init(sessionKey, channelEnableStatus, rxParameters);

      // init RX modules
      // Start to set the interval to save system active time
      clientUtil.setSystemActiveTime();
   };
}
